import { render, staticRenderFns } from "./IconBell.vue?vue&type=template&id=64bebadc&scoped=true"
import script from "./IconBell.vue?vue&type=script&lang=js"
export * from "./IconBell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bebadc",
  null
  
)

export default component.exports